import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'toggle-with-text',
  templateUrl: './toggle-with-text.component.html',
  styleUrls: ['./toggle-with-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleWithTextComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() disabled: boolean;
  @Input() isViewer: boolean;
  @Input() checked: boolean;

  @Output() toggleChange = new EventEmitter<boolean>();

  onToggle(event: any): void {
    this.toggleChange.emit(event);
  }
}
